import { useState } from "preact/hooks";
import { Route, Router, getCurrentUrl } from "preact-router";

import Banner from "./banner";
import Link from "./link";

import Header from "./header";
import Footer from "./footer";

import Home from "../routes/home";
import JohnPerkins from "../routes/candidates/john-perkins";
import ConnieWan from "../routes/candidates/connie-wan";
import Downloads from "../routes/downloads";
import Vote from "../routes/vote";
import NotFound from "../routes/not-found";

import Archive_2025 from "../routes/2025/home";
import EricaFloden_2025 from "../routes/2025/candidates/erica-floden";
import JimCline_2025 from "../routes/2025/candidates/jim-cline";
import JimClineHoaLetter_2025 from "../routes/2025/candidates/jim-cline/hoa-letter";
import RachelLong_2025 from "../routes/2025/candidates/rachel-long";
import Downloads_2025 from "../routes/2025/downloads";
import Vote_2025 from "../routes/2025/vote";

const App = () => {
  let [currentUrl, setCurrentUrl] = useState(getCurrentUrl());

  const handleRoute = async (e) => {
    setCurrentUrl(e.url);

    if (typeof window !== "undefined") {
      if (e.url.includes("#")) {
        // Scroll to top element matching id of hash
        const scrollToElement = () => {
          const element = document.getElementById(
            window.location.hash.substring(1),
          );
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          } else {
            // If element is not found, recheck on the next animation frame
            requestAnimationFrame(scrollToElement);
          }
        };
        requestAnimationFrame(scrollToElement);
      } else {
        // Scroll to top of page https://github.com/preactjs/preact-router/issues/319
        window.scrollTo({ top: 0 });
      }
    }
  };

  return (
    <div id="app">
      <Banner>
        Vote now! <Link href="/#how-to-vote">See details</Link>
      </Banner>
      <Header />
      <main>
        <div class="wrapper">
          <Router url={currentUrl} onChange={handleRoute}>
            <Route component={Home} path="/" />
            <Route component={JohnPerkins} path="/john-perkins" />
            <Route component={ConnieWan} path="/connie-wan" />
            <Route component={Downloads} path="/downloads" />
            <Route component={Vote} path="/vote" />

            {/* 2025 Archive */}
            <Route component={Archive_2025} path="/2025/" />
            <Route component={EricaFloden_2025} path="/2025/erica-floden" />
            <Route component={JimCline_2025} path="/2025/jim-cline" />
            <Route
              component={JimClineHoaLetter_2025}
              path="/2025/jim-cline/hoa-letter"
            />
            <Route component={RachelLong_2025} path="/2025/rachel-long" />
            <Route component={Downloads_2025} path="/2025/downloads" />
            <Route component={Vote_2025} path="/2025/vote" />

            {/* Not Found */}
            <Route component={NotFound} default />
          </Router>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default App;
